import { useQuery } from '@apollo/client/react';
import { GET_FANTASY_LEAGUE } from '../../../../graphql/queries/fantasyLeague';
import { GET_FANTASY_LEAGUE_TABS_SHELL } from '../../../../graphql/queries/fantasyLeagueTabsShell';
import type {
  GetFantasyLeagueQuery,
  GetFantasyLeagueQueryVariables,
  GetFantasyLeagueTabsShellQuery,
  GetFantasyLeagueTabsShellQueryVariables,
} from '../../../../types/graphql-generated';
import { LeagueImage } from '../../../components/LeagueImage';
import { LeagueHeaderCard } from './LeagueHeaderCard';
import { LeagueImageEditor } from './LeagueImageEditor';

interface LeagueHeaderProps {
  leagueId: string;
}

// Both queries are already loaded by PointsTab and the tabs page, so they are served from the cache.
export const LeagueHeader = ({ leagueId }: LeagueHeaderProps) => {
  const { data } = useQuery<GetFantasyLeagueQuery, GetFantasyLeagueQueryVariables>(GET_FANTASY_LEAGUE, {
    variables: { id: leagueId },
  });
  const { data: shellData } = useQuery<GetFantasyLeagueTabsShellQuery, GetFantasyLeagueTabsShellQueryVariables>(
    GET_FANTASY_LEAGUE_TABS_SHELL,
    { variables: { fantasyLeagueId: leagueId } }
  );

  const league = data?.fantasyLeague;
  if (!league) return null;

  const role = shellData?.currentFantasyLeagueMember?.role;
  const isAdmin = role === 'admin' || role === 'creator';

  const avatar = isAdmin ? (
    <LeagueImageEditor leagueId={leagueId} image={league.image} updatedAt={league.updatedAt} name={league.name} />
  ) : (
    <LeagueImage
      image={league.image}
      updatedAt={league.updatedAt}
      name={league.name}
      size={64}
      variant="onDark"
      className="ring-2 ring-white/70"
    />
  );

  return (
    <LeagueHeaderCard
      name={league.name}
      creatorName={league.creator?.fullName}
      participantsCount={league.participantsCount}
      maxPlayers={league.maxPlayers}
      isPublic={league.isPublic}
      avatar={avatar}
    />
  );
};
